// extracted by mini-css-extract-plugin
export default {"limitedMoreDialog":"BLimitedMore-module_limitedMoreDialog_d7d3a987","inputWrap":"BLimitedMore-module_inputWrap_a7be482c","content":"BLimitedMore-module_content_d5845e8e"};